<template>
  <ElButton :loading="loading" type="primary" @click="addToken">
    {{ $t('APP.API_AGENTS.REGENERATE_TOKEN') }}
  </ElButton>
</template>

<script>
import { AppApiAgents } from '@/api/api';
import packageName from '@/mixins/packageName';

export default {
  name: 'AppApiAgentsRegenerateButton',
  mixins: [packageName],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    addToken() {
      this.loading = true;

      return AppApiAgents.addToken({
        packageName: this.packageName,
      })
        .then(({ apiAgent, message }) => {
          if (message) {
            this.$message.success(message);
          }
          this.$emit('add', apiAgent);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
